<template>
  <div class="yxtbiz-signup-details pb24 bc-cCF5">
    <div class="flex space-between w1200 mt24 align-left">
      <div class="w100p bc-cCFF">
        <div class="flex">
          <div class="mt32 ml32 mb32">
            <yxtf-image v-show="data && data.coverUrl" class="d-img rtl4 rtr4 rbl4 rbr4" :src="data.coverUrl" fit="cover"></yxtf-image>
          </div>
          <div class="mt32 ml24 mr32 mb32 flex-value-1">
            <div class="mb12 fw500 fs24 ellipsis lineClamp2 word-break pt1 pb1">
              <yxtf-tag class="pl7 pr7 fs14 relative top-1" coverType="blue" size="small" type="info">{{data.appName}}</yxtf-tag>
              <span :title="data.projectName">{{data.projectName}}</span>
            </div>
            <div class="mb12 h48 bc-cCFA rtl4 rtr4 rbl4 rbr4 pl10">
              <template v-if="data.pointPrice">
                <img class="d-integral relative top-5" :src="`${staticBaseUrl}assets/141df7bc/85e5b524/a27406.svg`" alt="" />
                <span class="ml4 c-cC26 fs24 fw500">{{data.pointPrice}}</span>
                <span class="ml4 c-cC75 relative top-3">{{language().msg_integral}}</span>
                <span class="ml62 c-cC75 relative top-3" v-if="points.totalMallPoint">{{language().lbl_available_points}}：<span class="c-cC26">{{points.totalMallPoint.toLocaleString()}}</span></span>
              </template>
              <template v-else>
                <span class="c-cC59 fs20 fw500 ml2">{{language().msg_free}}</span>
              </template>
              <span class="pull-right c-cC59 mr16" v-if="timeCountDownValue && data.projectStatus === 2">
                <yxtf-svg class="d-time relative top3 mr4" width="16px" height="16px" icon-class="history" />
                <span>{{language().lbl_count_down}}：{{timeCountDownText}}</span>
              </span>
            </div>
            <div class="mb16 rtl4 rtr4 rbl4 rbr4 pl10">
              <div class="w416 inline-block vertical-align-top" v-for="(info, index) in infos" :key="index">
                <div class="mb8 c-cC8C relative">
                  <yxt-tooltip class="absolute top0 inline-block w58 justify ellipsis" effect="dark" :content="info.label" placement="top" :open-filter="true">
                    <span>{{info.label}}</span>
                  </yxt-tooltip>
                  <span class="absolute top0 left58">：</span>
                  <span class="c-cC26 block pl70" v-if="info.type === 'percentage'">
                    <yxtf-progress class="relative top-1" :percentage="info.value">
                      <span slot='content' class="c-cC26">{{info.value}}%（{{info.value === 100 ? language().msg_full : info.desc}}）</span>
                    </yxtf-progress>
                  </span>
                  <span class="c-cC26 block pl70 ellipsis lineClamp2 word-break lh22" v-else>
                    <yxtf-tooltip placement="top" effect="dark" open-filter>
                      <div class="ellipsis">
                        <yxtbiz-user-name :name="info.value || '--'" split="、" />
                      </div>
                      <yxtbiz-user-name slot="content" :name="info.value || '--'" split="、" />
                    </yxtf-tooltip>
                  </span>
                </div>
              </div>
            </div>
            <div class="rtl4 rtr4 rbl4 rbr4 pl10">
              <template  v-for="(opt, index) in opts" >
                <yxt-popover
                  :key="index"
                  v-if="opt.key!=='my' &&  opt.key!=='all' && (ruleResultUsers.length>0 || (extraConditionArr && extraConditionArr.length>0))"
                  placement="bottom"
                  max-width="560"
                  max-height="300"
                  class="mr16"
                  trigger="hover"
                  :visible-arrow="true"
                >
                  <yxtf-button slot="reference" :class="opt.class" size="larger2" :type="opt.class ? '' : 'primary'" :plain="!!opt.class" @click.stop="goOpt(opt)">{{opt.label}}</yxtf-button>
                   <div class="yxtbiz-signup">
                    <div class="mah276">
                      <div class="c-cC26 fs16 mb4 fw500">{{language().tit_non}}</div>
                      <div class="c-cC75 fs14">{{data.requireCount===1?language().lbl_check_con1:language().lbl_check_con0}}</div>
                      <template v-if="ruleResultUsers.length>0">
                        <div v-for="(item, index) in ruleResultUsers[0].rules" :class="`fs14 c-cC26 ${index===0?'mt16':'mt24'}`" :key="index">
                          <span class="dot bc-cCD8 relative top-1"></span>
                          <span v-if="item.ruleCode==='cers'">{{item.ruleName}}（{{item.requireCount ===0?language().lbl_check_concer00:language().lbl_check_concer1}}）</span>
                          <span v-else-if="item.ruleCode==='exams'">{{item.ruleName}}（{{item.requireCount ===0?language().lbl_check_conexam00:language().lbl_check_conexam1}}）</span>
                          <span v-else>{{item.ruleName}}</span>
                          <br>
                          <span class="c-cC75 fs14 ml16 inline-block">{{item.ruleValueInfo}}</span>
                        </div>
                      </template>
                      <template v-if="extraConditionArr && extraConditionArr.length>0">
                        <div v-for="(item, index) in extraConditionArr" :class="`fs14 c-cC26 ${(index===0 && !ruleResultUsers&&!ruleResultUsers[0] &&!ruleResultUsers[0].rules)?'mt16':'mt24'}`" :key="index">
                          <span class="dot bc-cCD8 relative top-1"></span>
                          <span v-if="item.ruleCode==='cers'">{{item.ruleName}}（{{item.requireCount ===0?language().lbl_check_concer00:language().lbl_check_concer1}}）</span>
                          <span v-else-if="item.ruleCode==='exams'">{{item.ruleName}}（{{item.requireCount ===0?language().lbl_check_conexam00:language().lbl_check_conexam1}}）</span>
                          <span v-else>{{item.ruleName}}</span>
                          <br>
                          <span class="c-cC75 fs14 ml16 inline-block">{{item.ruleValueInfo}}</span>
                        </div>
                      </template>
                    </div>
                  </div>
                </yxt-popover>
                <yxtf-tooltip v-else :key="index" placement="top" :content="opt.title" :disabled="!opt.title">
                  <yxtf-button :class="opt.class" size="larger2" :type="opt.class ? '' : 'primary'" :plain="!!opt.class" @click.stop="goOpt(opt)">{{opt.label}}</yxtf-button>
                </yxtf-tooltip>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix space-between w1200 mt24 align-left">
      <div class="w100p-312-24 bc-cCFF pull-left">
        <yxtf-tabs v-model="tabActive">
          <yxtf-tab-pane v-for="(tab, index) in tabs.filter(_ => _.value === '2' ? ((rules.datas || []).length > 0||showConditionTab ): true)" :key="index" :label="tab.label" :name="tab.value">
            <div class="mt24 hm-509">
              <template v-if="tabActive === '2'">
                <div class="ml32 mb24 c-cC75 fs14">{{language().msg_rule}}{{data.requireCount===1?language().lbl_check_con1:language().lbl_check_con0}}</div>
                <div v-for="(rule, index) in rules.datas" :key="index" :class="`mb32 ml32 mr32`">
                  <div class="c-cC26 fs16 mb8 fw500">{{rule.ruleName}}</div>
                  <div class="c-cC8C mb8 fs14" v-if="rule.ruleCode==='cers'">{{rule.requireCount ===0?language().lbl_check_concer00:language().lbl_check_concer1}}</div>
                  <div class="c-cC8C mb8 fs14" v-if="rule.ruleCode==='exams'">{{rule.requireCount ===0?language().lbl_check_conexam00:language().lbl_check_conexam1}}</div>
                  <div class="c-cC75 fs14 word-break-all ">{{rule.ruleValueInfo}}</div>
                </div>
                <slot name="condition"></slot>
              </template>
            <slot v-else-if="tabActive === '1'" name="content"></slot>
            </div>
          </yxtf-tab-pane>
        </yxtf-tabs>
      </div>
      <div class="w312 bc-cCFF pull-right">
        <div class="mt24 ml24 mr24 fs18 fw500">{{language().tit_calendar}}</div>
        <div :class="dayData && dayData.length ? '' : 'mb24'">
          <signup-calendar class="hm-134" :value="currentDate" :dotDays="dotDays" @week="getCalendar" @input="queryList"></signup-calendar>
          <div class="relative ml16 mr16 h72 pl24 bc-cCF5-hover pt12 border-box rtl4 rtr4 rbl4 rbr4 pointer" v-for="(item, index) in dayData" :key="index" @click="toDetail(item)">
            <span class="c-cCD9 fs14 absolute left8">{{(index + 1 + '').padStart(2, '0')}}</span>
            <div class="c-cC26 fs14 ellipsis" :title="`【${item.appName || ''}】${item.projectName || ''}`">【{{item.appName || ''}}】{{item.projectName || ''}}</div>
            <div class="c-cC8C fs12 mt4 pl8">{{timeText2(item.startTime, item.endTime, item.projectStatus)}}</div>
          </div>
          <div class="ml16 mr16 h46 c-cC59 fs14 align-center bt1 pointer" v-if="dayDataCount > 5" @click.stop="$emit('toHome')">
            <yxtf-button type="text">{{language().btn_more}}</yxtf-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import signupCalendar from '../../components/calendar.vue';
export default {
  name: 'YxtbizSignupDetails',
  inject: ['language'],
  components: {
    signupCalendar
  },
  props: {
    id: {
      type: String,
      default: '1522770722245263361'
    },
    extendedInfo: {
      type: Array,
      default() {
        return [];
      }
    },
    // 让业务方自主控制立即报名的状态，true可报名  false 置灰
    signBtnActive: {
      type: Boolean,
      default: true
    },
    // 让业务方自主控制是否显示报名条件tab，true显示  false 置灰
    showConditionTab: {
      type: Boolean,
      default: false
    },
    extraConditionArr: {
      type: Array,
      default: ()=>{
        return [];
      }
    },
    isShowUserSelector: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 存在报名的日期
      dotDays: [],
      // 日期对应数据
      dayData: [],
      dayDataCount: 0,
      // 规则验证
      failNum: 0,
      // 到计时值
      timeCountDownValue: 0,
      // 当前时间
      timeValue: 0,
      // 详情对象
      data: {},
      // 积分兑现
      points: {},
      // 报名对象
      siginup: {},
      // 规则列表
      rules: [],
      // 缓存定时器
      si: null,
      // 详情内容tab
      tabActive: '1',
      tabs: [],
      ruleResult: {},
      ruleResultUsers: [],
      isload: false,
      staticBaseUrl: this.$staticBaseUrl
    };
  },
  computed: {
    // 报名信息
    infos() {
      return [
        {
          label: this.language().lbl_registration_time,
          value: this.timeText(this.data.startTime, this.data.endTime, this.data.projectStatus)
        },
        ...(this.data.maxQuota ? [{
          label: this.language().lbl_progress,
          type: 'percentage',
          value: this.toPercentage(this.data.actualNum, this.data.maxQuota),
          desc: this.data.actualNum + ' / ' + this.data.maxQuota
        }] : []),
        ...(this.data.owners && this.data.owners.length ? [{
          label: this.language().lbl_admin,
          value: this.data.owners.map(_ => _.fullname).join('、')
        }] : []),
        ...this.extendedInfo
      ];
    },
    // 当前日期
    currentDate() {
      return moment(this.timeValue).format('YYYY-MM-DD');
    },
    // 立即报名控制
    opts() {
      const btns = [];
      // 时间验证
      const timeValue = this.timeVerify(this.data.projectStatus);
      // 名额验证
      const numValue = this.numVerify(this.data.actualNum, this.data.maxQuota);
      // 立即报名
      if (this.data.userCanEnrolled || this.data.userAllowOtherEnroll) {
        if (!this.isload || !this.signBtnActive) {
          btns.push({
            class: 'is-disabled',
            label: this.language().btn_sign_up_now
          });
        } else if (timeValue) {
          btns.push(timeValue);
        } else {
          if (numValue) {
            btns.push(numValue);
          } else {
            if (this.data.userCanEnrolled) {
              // 积分不足
              const priceValue = this.priceVerify(this.data.pointPrice, this.points.totalMallPoint || 0);
              if (priceValue) {
                btns.push(priceValue);
              } else {
                // 其它条件
                const rules = this.rulesVerify(this.failNum);
                if (rules) {
                  btns.push(rules);
                } else {
                  btns.push({
                    class: '',
                    label: this.language().btn_sign_up_now,
                    key: 'run'
                  });
                }
              }
            }
          }
        }
      }
      // 代报名
      if (this.data.userAllowOtherEnroll) {
        if (!timeValue && !numValue) {
          btns.push({
            class: btns.length ? 'is-plain' : '',
            label: this.language().btn_all,
            key: 'all'
          });
        }
      }
      // 我的报名
      if (this.data.userEnrolled || this.data.userOtherEnrolled) {
        btns.push({
          class: btns.length ? 'is-plain' : '',
          label: this.language().btn_my,
          key: 'my'
        });
      }
      return btns;
    },
    // 倒计时文本
    timeCountDownText() {
      const d = parseInt(this.timeCountDownValue / 86400000, 10);
      const h = parseInt((this.timeCountDownValue % 86400000) / 3600000, 10);
      const m = parseInt(((this.timeCountDownValue % 86400000) % 3600000) / 60000, 10);
      const s = parseInt((((this.timeCountDownValue % 86400000) % 3600000) % 60000) / 1000, 10);
      return this.language().msg_format
        .replace('$DD', (d + '').padStart(2, '0'))
        .replace('$HH', (h + '').padStart(2, '0'))
        .replace('$mm', (m + '').padStart(2, '0'))
        .replace('$ss', (s + '').padStart(2, '0'));
    }
  },
  methods: {
    imgError() {
      this.data.coverUrl = this.$staticBaseUrl + 'ufd/55a3e0/o2o/pc/other/project.png';
    },
    toDetail(row) {
      window.location.href = row.shortUrl;
    },
    // 查询指定日期下可以报名的数据
    async queryList(date) {
      const SDK = this.$parent.SDK;
      const res = await SDK.getProjects({
        appIds: [],
        searchType: 1,
        startTimeType: 5,
        projectStatus: 1,
        endDate: moment(date).format('YYYY-MM-DD'),
        startDate: moment(date).format('YYYY-MM-DD'),
        limit: 5,
        offset: 0
      });
      this.$parent.fmessage(res);
      this.dayData = res.datas;
      this.dayDataCount = res.paging.count;
    },
    // 日历查询
    async getCalendar(start, end) {
      const SDK = this.$parent.SDK;
      // 获取详情
      const res = await SDK.getCalendar({
        startDate: moment(start).format('YYYY-MM-DD'),
        endDate: moment(end).format('YYYY-MM-DD')
      });
      this.$parent.fmessage(res);
      if (res.datas && res.datas.length) {
        this.dotDays = res.datas.filter(_ => _.existProject).map(_ => _.date);
      }
    },
    // 超100 = 100
    toPercentage(x, y) {
      const value = parseInt(x / y * 100, 10);
      return value > 100 ? 100 : value;
    },
    // 报名规则验证
    rulesVerify(rulesValue) {
      // 其它条件
      if (rulesValue) {
        return {
          class: 'is-disabled',
          label: this.language().btn_sign_up_now,
          title: this.language().tit_unsatisfied
        };
      }
    },
    // 报名积分验证
    priceVerify(pointPrice, totalMallPoint) {
      if (pointPrice && pointPrice > totalMallPoint) {
        return {
          class: 'is-disabled',
          label: this.language().btn_sign_up_now,
          title: this.language().tip_insufficient_points
        };
      }
    },
    // 报名名额验证
    numVerify(actualNum, maxQuota) {
      // 名额验证
      if (maxQuota && actualNum >= maxQuota) {
        return {
          class: 'is-disabled',
          label: this.language().msg_quota_full
        };
      }
    },
    // 报名时间验证
    timeVerify(projectStatus) {
      if (projectStatus === 6) {
        return {
          class: 'is-disabled',
          label: this.language().btn_projects_expired
        };
      }
    },
    // 时间显示生成
    timeText(startTime, endTime, projectStatus) {
      if (startTime && endTime) {
        return startTime + ' ～ ' + endTime;
      } else {
        return this.language().msg_long_term;
      }
    },
    // 时间显示生成
    timeText2(startTime, endTime, projectStatus) {
      if (startTime && endTime) {
        if (projectStatus === 2 || projectStatus === 6 || projectStatus === 4) {
          return this.language().msg_deadline.replace('$time', moment(endTime).format('MM-DD HH:mm'));
        } else {
          return moment(startTime).format('MM-DD HH:mm') + ' ～ ' + moment(endTime).format('MM-DD HH:mm');
        }
      } else {
        return this.language().msg_long_term;
      }
    },
    // 执行前置条件验证
    async exeRules(users = [], rules = []) {
      if (this.siginup) {
        return await this.siginup.check(users.map(_ => _.id), rules);
      }
    },
    // 操作
    async goOpt(opt) {
      // 有操作指令才触发
      if (opt.key) {
        if (opt.key === 'run') {
          // sessionStorage.signupType主要是为了区分订单详情是自报名还是代报名
          sessionStorage.setItem('signupType', 'run');
          this.$parent.setParams(this.id, 'users', []);
          this.$emit('toOrder', this.id);
        } else if (opt.key === 'my') {
          this.$emit('toMy', this.id);
        } else if (opt.key === 'all') {
          // sessionStorage.signupType主要是为了区分订单详情是自报名还是代报名
          sessionStorage.setItem('signupType', 'all');
          this.$parent.handleOpen({
            type: 'userSelector'
          }, {
            max: this.data.maxQuota ? (this.data.maxQuota || 0) - (this.data.actualNum || 0) : 0,
            // 代理请求
            getData: async(params, cb) => {
              const res = await this.siginup.getRangeUsers(params);
              this.$parent.fmessage(res);
              cb(res);
            }
          }, () => {
            this.$parent.handleClose();
          }, users => {
            this.$parent.setParams(this.id, 'users', users);
            this.$emit('toOrder', this.id);
            this.$parent.handleClose();
          });
        }
      }
    }
  },
  async created() {
    const SDK = this.$parent.SDK;
    // 获取详情
    this.data = await SDK.getProjectDetail(this.id);
    this.$emit('callback', this.data);
    // 业务需要 获取额外的规则，返回的值赋值给this.extraConditionArr
    this.$emit('extraCondition', window.localStorage.getItem('userId') || this.data.owners[0]);
    this.$parent.fmessage(this.data);
    // 获取积分
    this.points = await SDK.getCurrentUserPoints();
    this.$parent.fmessage(this.points);
    // 获取详情内容页签
    this.tabs = SDK.getCodes('pc').contentItems;
    this.$parent.fmessage(this.tabs);
    // 获取时间
    const systemTime = await SDK.getSystemTime();
    this.$parent.fmessage(systemTime);
    this.timeValue = parseInt(systemTime.data, 10);
    const timeValueEnd = this.data.endTime ? (new Date(this.data.endTime.replace(/-/g, '/'))).valueOf() : this.timeValue;
    const timeValueStart = this.data.startTime ? (new Date(this.data.startTime.replace(/-/g, '/'))).valueOf() : this.timeValue;
    if (this.timeValue < timeValueStart) {
      this.timeCountDownValue = 0;
    } else if (this.timeValue > timeValueEnd) {
      this.timeCountDownValue = 0;
    } else {
      this.timeCountDownValue = timeValueEnd - this.timeValue;
    }
    if (this.timeCountDownValue > 0) {
      this.si = setInterval(() => {
        if (this.timeCountDownValue > 0) {
          this.timeCountDownValue = this.timeCountDownValue - 1000;
        } else {
          if (this.si) clearInterval(this.si);
          this.si = null;
          this.timeCountDownValue = 0;
        }
      }, 1000);
    } else {
      this.timeCountDownValue = 0;
    }
    // 注册项目
    this.siginup = new SDK(this.data.id);
    // 按钮控制
    const kongz = await this.siginup.getButtons(this.id);
    this.$parent.fmessage(kongz);
    this.data = {
      ...this.data,
      ...kongz
    };
    // 规则验证
    this.rules = await this.siginup.getRules();
    this.$parent.fmessage(this.rules);
    this.ruleResult = await this.exeRules([], this.rules.datas);
    this.$parent.fmessage(this.ruleResult);
    this.isload = true;
    this.failNum = this.ruleResult.failNum;
    this.ruleResultUsers = this.ruleResult.failUsers;
    this.queryList(new Date(this.timeValue));
    // 弹出代报名
    // 时间验证
    const timeValue = this.timeVerify(this.data.projectStatus);
    // 名额验证
    const numValue = this.numVerify(this.data.actualNum, this.data.maxQuota);
    if (this.isShowUserSelector && this.data.userAllowOtherEnroll && !timeValue && !numValue) {
      this.goOpt({key: 'all'});
    }
  },
  beforeDestroy() {
    if (this.si) clearInterval(this.si);
    this.si = null;
  }
};
</script>

<style lang="scss" scoped>
.yxtbiz-signup-details {
  display: flex;
  flex-direction: column;
  .d-img {
    width: 246px;
    height: 148px;
  }
  .d-icon {
    width: 24px;
    height: 24px;
  }
  .d-integral {
    height: 24px;
    width: 24px;
  }
  .d-time {
    height: 16px;
    width: 16px;
  }
}
</style>
